export default __webpack_public_path__ + "static/media/ki.32371bc8.svg";